import {
  FETCH_START,
  FETCH_END,
  GET_PERIOD_DEFINITIONS_SUCCESS,
  GET_PERIOD_DEFINITIONS_FAIL,
  GET_PERIOD_DEFINITION_SUCCESS,
  GET_PERIOD_DEFINITION_FAIL,
  CREATE_PERIOD_DEFINITION_SUCCESS,
  CREATE_PERIOD_DEFINITION_FAIL,
  UPDATE_PERIOD_DEFINITION_SUCCESS,
  UPDATE_PERIOD_DEFINITION_FAIL,
  DELETE_PERIOD_DEFINITION_SUCCESS,
  DELETE_PERIOD_DEFINITION_FAIL,
  GENERATE_PERIODS_SUCCESS,
  GENERATE_PERIODS_FAIL,
  GENERATE_PERIODS_BY_NAME_YEAR_SUCCESS,
  GENERATE_PERIODS_BY_NAME_YEAR_FAIL,
} from '../../actions/CalendarManager/ActionTypes';

const initialState = {
  loading: false,
  periodDefinitions: [],
  selectedPeriodDefinition: null,
  generatedPeriods: [],
  error: null,
};

const CalendarManagerReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_START:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_END:
      return {
        ...state,
        loading: false,
      };
    case GET_PERIOD_DEFINITIONS_SUCCESS:
      return {
        ...state,
        periodDefinitions: action.data,
        loading: false,
        error: null,
      };
    case GET_PERIOD_DEFINITIONS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case GET_PERIOD_DEFINITION_SUCCESS:
      return {
        ...state,
        selectedPeriodDefinition: action.data,
        loading: false,
        error: null,
      };
    case GET_PERIOD_DEFINITION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case CREATE_PERIOD_DEFINITION_SUCCESS:
      return {
        ...state,
        periodDefinitions: [...state.periodDefinitions, action.data],
        selectedPeriodDefinition: action.data,
        loading: false,
        error: null,
      };
    case CREATE_PERIOD_DEFINITION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case UPDATE_PERIOD_DEFINITION_SUCCESS:
      return {
        ...state,
        periodDefinitions: state.periodDefinitions.map((def) =>
          def.id === action.data.id ? action.data : def,
        ),
        selectedPeriodDefinition: action.data,
        loading: false,
        error: null,
      };
    case UPDATE_PERIOD_DEFINITION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case DELETE_PERIOD_DEFINITION_SUCCESS:
      return {
        ...state,
        periodDefinitions: state.periodDefinitions.filter(
          (def) => def.id !== action.id,
        ),
        selectedPeriodDefinition:
          state.selectedPeriodDefinition?.id === action.id
            ? null
            : state.selectedPeriodDefinition,
        loading: false,
        error: null,
      };
    case DELETE_PERIOD_DEFINITION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case GENERATE_PERIODS_SUCCESS:
      return {
        ...state,
        generatedPeriods: action.data,
        error: null,
      };
    case GENERATE_PERIODS_FAIL:
      return {
        ...state,
        error: action.error,
      };
    case GENERATE_PERIODS_BY_NAME_YEAR_SUCCESS:
      return {
        ...state,
        generatedPeriods: action.data,
        error: null,
      };
    case GENERATE_PERIODS_BY_NAME_YEAR_FAIL:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
};

export default CalendarManagerReducer;

